<template>
  <div class="i-filters" @mouseenter="onMouseEnter()" @mouseleave="onMouseLeave()">
    <div ref="container" class="i-filters-container" :style="computedContainerStyle" tabindex="-1">
      <slot></slot>
    </div>
    <q-separator v-if="shouldExpand" vertical style="margin:0 1em" />
    <div v-if="shouldExpand" class="i-filters-bar" :style="computedBarStyle">
      <i-btn round flat :icon="computedExpanded ? 'expand_less' : 'expand_more'" @click="onToggleExpand()" :tooltip-text="computedExpanded?'收起':'展开'"
        tooltip-position="left" :glossy="false" />
      <i-btn round flat icon="search" v-show="computedExpanded" :loading="searchLoading" :disable="searchDisable" @click="$emit('search')"
        tooltip-text="查询" tooltip-position="left" :glossy="false"/>
      <i-btn round flat icon="undo" v-show="computedExpanded" :loading="resetLoading" :disable="resetDisable" @click="$emit('reset')"
        tooltip-text="重置" tooltip-position="left" :glossy="false"/>
    </div>
  </div>
</template>
<script>
import utils from '@/lib/utils'

export default {
  data () {
    return {
      shouldExpand: false,
      expandByMouseHover: false,
      expandByContainerActive: false
    }
  },
  props: {
    searchLoading: Boolean,
    searchDisable: Boolean,
    resetLoading: Boolean,
    resetDisable: Boolean,
    autoExpand: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedExpanded () {
      return this.autoExpand || (this.shouldExpand && (this.expandByMouseHover || this.expandByContainerActive))
    },
    computedContainerStyle () {
      const maxHeight = this.computedExpanded && this.$refs.container ? this.$refs.container.scrollHeight : (this.$q.screen.lt.lg ? 60 : this.autoExpand ? 192 : 76)
      return {
        maxHeight: `${maxHeight}px`
      }
    },
    computedBarStyle () {
      const maxHeight = this.computedExpanded && this.$refs.container ? this.$refs.container.scrollHeight : 50
      return {
        maxHeight: `${maxHeight}px`
      }
    }
  },
  created () {
    this.containerResizeObserver = new ResizeObserver((entries) => {
      this.detectShouldExpand()
    })
  },
  mounted () {
    // this.expandByMouseHover = this.autoExpand
    // this.shouldExpand = this.autoExpand
    this.switchDetectContainerActive(true)
    this.containerResizeObserver.observe(this.$refs.container)
    this.detectShouldExpand()
  },
  beforeDestroy () {
    // this.containerResizeObserver.unobserve(this.$refs.container)
    this.containerResizeObserver.disconnect()
    this.switchDetectContainerActive(false)
  },
  watch: {
    expanded (newVal) {
      this.switchDetectContainerActive(!newVal)
    }
  },
  methods: {
    detectShouldExpand () {
      const height = this.$refs.container?.scrollHeight
      this.shouldExpand = height && height > 80
      return this.shouldExpand
    },
    onMouseEnter () {
      this.expandByMouseHover = true
    },
    onMouseLeave () {
      this.detectContainerActive()
      this.expandByMouseHover = false
    },
    onToggleExpand () {
      if (this.computedExpanded) {
        this.expandByMouseHover = false
        this.expandByContainerActive = false
        this.$emit('closeExpand')
        this.$refs.container && this.$refs.container.blur()
      } else {
        this.expandByMouseHover = true
      }
    },
    detectContainerActive (immediate) {
      const active = utils.isAncestorElementOf(this.$refs.container, document.activeElement)
      if (active !== this.expandByContainerActive) {
        if (immediate === true || active) {
          this.expandByContainerActive = active
        } else {
          setTimeout(() => this.detectContainerActive(true), 500)
        }
      }
    },
    switchDetectContainerActive (on) {
      utils[on ? 'onActiveElementChanged' : 'offActiveElementChanged'](this.detectContainerActive)
    }
  }
}
</script>

<style scoped lang="scss">
// @import "@/styles/quasar.variables.scss";
.i-filters {
  padding: 0.5em 1em 0.5em 1em;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  display: grid;
  grid-template-columns: 1fr auto auto;
}
// .i-filters:focus {
//   box-shadow: 0px 0px 10px 0px scale-color($primary, $lightness: 20%);
// }

.i-filters-container {
  transition: max-height 0.15s ease;
  overflow: hidden;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  > * {
    flex-basis: 240px;
    width: 240px;
    margin-right: 0.5em;
  }
  &-actions {
    > * {
      margin: 5px 10px 0 0;
    }
    flex-basis: 270px;
  }
}

.i-filters-bar {
  transition: max-height 0.15s ease;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
</style>
